<template>
    <b-row>
        <Sidebar/>
        <b-col md="10" offset-md="2">
            <div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
                <h1 class="h2">Etapa: {{block.title}}</h1>
                <div class="btn-toolbar mb-2 mb-md-0">
                    <div class="btn-group mr-2">
                        <b-button variant="outline-secondary" to="/etapas/nuevo">Nueva</b-button>
                        <b-button variant="outline-primary" :to="'/etapas/editar/' + this.$route.params.id">Editar</b-button>
                    </div>
                </div>
            </div>
            <p v-if="isLoading">Cargando...</p>
            <template v-else>
                <b-row>
                    <b-col class="md-12">
                        <b-list-group>
                            <b-list-group-item><b>Nombre:</b><span>{{block.title}}</span></b-list-group-item>
                        </b-list-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="12">
                        <br>
                        <h3 class="h4">Multimedia</h3>
                    </b-col>
                    <b-col md="6">
                        <div class="embed-responsive embed-responsive-16by9">
                            <iframe class="embed-responsive-item" :src="block.video" frameborder="0"
                                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                    allowfullscreen></iframe>
                        </div>
                    </b-col>
                    <b-col md="6">
                        <b-table hover v-bind:items="block.images" v-bind:fields="imageHeaders" outlined
                                 head-variant="light">
                            <template slot="image" slot-scope="data">
                                <a :href="data.item.url" target="_blank"><img class="thumb" :src="data.item.url"/></a>
                            </template>
                        </b-table>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col md="12">
                        <br>
                        <h3 class="h4">Tareas</h3>
                        <b-table hover v-bind:items="tasks" v-bind:fields="taskHeaders" outlined
                                 head-variant="light">
                            <template slot="finished" slot-scope="data">
                                <span v-html="(data.item.finished === true ) ? 'Finalizado' : 'En progreso'"></span>
                            </template>
                            <template slot="finish_date" slot-scope="data">
                                <span>{{data.item.finish_date | moment("DD/MM/YYYY")}}</span>
                            </template>
                            <template slot="attachments" slot-scope="data">
                                <div v-if="data.item.documents">
                                    <div v-for="document in data.item.documents"><a target="_blank" :href="document.file.url" >{{document.title}}</a></div>
                                </div>
                                <div v-else>Sin adjunto</div>
                            </template>
                            <template slot="comments" slot-scope="data">
                                <div v-html="data.item.content"></div>
                            </template>
                        </b-table>
                    </b-col>
                </b-row>

            </template>
        </b-col>
    </b-row>
</template>

<script>
    import {mapGetters} from 'vuex'

    export default {
        name: "StagesView",
        data() {
            return {
                isLoading: true,
                imageHeaders: [
                    {key: 'image', label: 'Imagen', sortable: false},
                    {key: 'url', label: 'Ruta de archivo', sortable: true}
                ],
                taskHeaders: [
                    {key: 'title', label: 'Tarea', sortable: true},
                    {key: 'finished', label: 'Estado', sortable: true},
                    {key: 'finish_date', label: 'Fecha', sortable: true},
                    {key: 'attachments', label: 'Adjunto', sortable: true},
                    {key: 'content', label: 'Comentarios', sortable: true},
                    // {key: 'actions', label: 'Acciones', sortable: false},
                ],
            }
        },
        computed: {
            ...mapGetters({
                block: 'stages/getEntries',
                tasks: 'stages/getTasks'
            })
        },
        created() {
            this.isLoading = false;

            this.$store.dispatch('stages/loadEntries', this.$route.params.id).then(() => {
                this.isLoading = false;
            });

        }
    }
</script>

<style scoped>
    .list-group-item > b {
        flex: 2;
    }

    .thumb {
        max-width: 128px;
    }
</style>